"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
const Pen = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 16,
  height: 21,
  viewBox: "0 0 16 21",
  fill: "none"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.82282 4.26269C7.21786 3.15658 8.78214 3.15658 9.17718 4.26268L10.6905 8.50007H5.30947L6.82282 4.26269ZM4.41661 11.0001L3.21847 14.3549C3.0739 14.7597 3 15.1863 3 15.6161V21.0001H0.5V15.6161C0.5 14.8997 0.623165 14.1887 0.864113 13.514L4.46847 3.42184C5.65358 0.103529 10.3464 0.103523 11.5315 3.42184L15.1359 13.514C15.3768 14.1887 15.5 14.8997 15.5 15.6161V21.0001H13V15.6161C13 15.1863 12.9261 14.7597 12.7815 14.3549L11.5834 11.0001H4.41661Z",
  className: "fill"
}));
var _default = exports.default = Pen;